import { inject } from 'vue';
import type mixpanel from 'mixpanel-browser';

export function useMixpanel() {
  const $mixpanel = inject<typeof mixpanel>('mixpanel');

  if (!$mixpanel) {
    console.warn('Mixpanel not found in globalProperties');
    return {
      track: () => {},
      page: () => {},
    };
  }

  const track = (event: string, properties?: Record<string, any>) => {
    $mixpanel.track(event, properties);
  };

  const page = (event: string, properties?: Record<string, any>) => {
    $mixpanel.track(`Viewed ${event}`, properties);
  };

  return { track, page };
}
